import React from 'react';
import * as styles from './News.module.scss';
import { useStaticQuery, graphql } from 'gatsby';
import favicon from "@images/home/favicon.ico";

import NewsPageBase from '@components/NewsPage';
import Layout from "@home/Layout";
import Seo from "@components/seo";
import { Helmet } from 'react-helmet';

const News = () => {
  const data = useStaticQuery(graphql`
    query {
      allPrismicNewsPost(filter: {data: {page_selection: { in:["Gomes", "Homepage"]}}}) {
        nodes {
          tags
          id
          data {
            featured
            external_link {
              url
              target
            }
            title {
              text
            }
            intro_text {
              text
            }
            author {
              text
              html
            }
            author_image {
              url
            }
            main_image {
              url
            }
            small_image {
              url
            }
            page_selection
          }
        }
      }
    }
  `);

  const newsPosts = data.allPrismicNewsPost.nodes;

  return (
    <Layout>
      <Seo title={"News | By Gomes"} 
      icon={favicon}
      description="Gomes Group is invested in seeing the New Jersey region flourish through inventive design, sustainable construction, and meaningful relationships."
      />
      <Helmet>
           <meta property="og:title" content="News | By Gomes" />
           <meta property="og:description" content="Gomes Group is invested in seeing the New Jersey region flourish through inventive design, sustainable construction, and meaningful relationships." />
           <meta property="og:image" content="https://images.prismic.io/bygomes/6fbbce55-8d4b-46f7-9baf-0b80ec2e4ab6_Gomes_Homepage_Header.jpg?ixlib=gatsbyFP&q=80&auto=compress%2Cformat" />
           <meta property="og:url" content="https://bygomes.com" />
           <meta property="og:type" content="website" />
      </Helmet>        
      <NewsPageBase styles={styles} newsPosts={newsPosts} CustomNewsMore={() => <button>LOAD MORE NEWS</button>} />    
    </Layout>
  );
};

export default News;
